<div class="row space-between gap-8">
    <h1>Token Summary</h1>
    <rr-btn type="Secondary" iconStart="save" (click)="getCsv()"
        >Export as CSV</rr-btn
    >
</div>
<table class="w100">
    <thead>
        <tr>
            <th>Streamname</th>
            <th>Stepname</th>
            <th>LLM</th>
            <th>Vorkommnisse</th>
            <th>total Prompt Token</th>
            <th>total Response Token</th>
            <th>durch. Token</th>
            <th class="text-right">Kosten Input €</th>
            <th class="text-right">Kosten Output €</th>
            <th class="text-right">Kosten Total €</th>
            <th class="text-right">Kosten Durchschnitt €</th>
        </tr>
    </thead>
    <tbody>
        @for (data of tokenData; track data) {
            <tr class="card">
                <td>
                    {{ data.streamName ? data.streamName : data.streamTypeId }}
                </td>
                <td>
                    {{ data.stepName ? data.stepName : data.stepId }}
                </td>
                <td>{{ data.llmId }}</td>
                <td>{{ data.groupCount }}</td>
                <td>{{ data.totalPromptTokens }}</td>
                <td>{{ data.totalResponseTokens }}</td>
                <td>{{ (data.totalTokens / data.groupCount).toFixed(2) }}</td>
                <td class="money">
                    {{
                        (
                            data.totalPromptTokens *
                            (tokenCosts[data.llmId].input || defaultInputCost)
                        ).toFixed(2)
                    }}
                    €
                </td>
                <td class="money">
                    {{
                        (
                            data.totalResponseTokens *
                            (tokenCosts[data.llmId].output || defaultOutputCost)
                        ).toFixed(2)
                    }}
                    €
                </td>
                <td class="money">
                    {{
                        (
                            data.totalPromptTokens *
                                (tokenCosts[data.llmId].input ||
                                    defaultInputCost) +
                            data.totalResponseTokens *
                                (tokenCosts[data.llmId].output ||
                                    defaultOutputCost)
                        ).toFixed(2)
                    }}
                    €
                </td>
                <td class="money">
                    {{
                        (
                            (data.totalPromptTokens *
                                (tokenCosts[data.llmId].input ||
                                    defaultInputCost) +
                                data.totalResponseTokens *
                                    (tokenCosts[data.llmId].output ||
                                        defaultOutputCost)) /
                            data.groupCount
                        ).toFixed(4)
                    }}
                    €
                </td>
            </tr>
        }
    </tbody>
</table>
